import React, { useState, useEffect } from 'react';

const PromptForm = ({ prompt, onSubmit, onReset }) => {
	const [condition, setCondition] = useState('');
	const [promptText, setPromptText] = useState('');
	const [promptId, setPromptId] = useState('');
	const [formTitle, setFormTitle] = useState('Create Prompt');
	const [conditionDisabled, setConditionDisabled] = useState(false);

	useEffect(() => {
		if (prompt) {
			setCondition(prompt.condition || '');
			setPromptText(prompt.prompt || '');
			setPromptId(prompt.id || '');
			setFormTitle('Edit Prompt');
			setConditionDisabled(true); // Disable condition field in edit mode
		} else {
			setCondition('');
			setPromptText('');
			setPromptId('');
			setFormTitle('Create Prompt');
			setConditionDisabled(false);
		}
	}, [prompt]);

	const handleSubmit = (e) => {
		e.preventDefault();

		const formData = {
			condition,
			prompt: promptText,
		};

		onSubmit(formData);
	};

	const handleReset = () => {
		setCondition('');
		setPromptText('');
		setPromptId('');
		setFormTitle('Create Prompt');
		setConditionDisabled(false);

		if (onReset) {
			onReset();
		}
	};

	return (
		<form id="promptForm" onSubmit={handleSubmit}>
			<h5 className="mb-3" id="promptFormTitle">
				{formTitle}
			</h5>
			<input type="hidden" id="prompt-id" value={promptId} />

			<div className="form-group">
				<label htmlFor="condition">Condition:</label>
				<input
					type="text"
					id="condition"
					className="form-control"
					value={condition}
					onChange={(e) => setCondition(e.target.value)}
					disabled={conditionDisabled}
					required
				/>
			</div>

			<div className="form-group">
				<label htmlFor="prompt">Prompt:</label>
				<textarea
					id="prompt"
					rows="4"
					className="form-control"
					value={promptText}
					onChange={(e) => setPromptText(e.target.value)}
					required
				></textarea>
			</div>

			<div className="form-group">
				<button type="submit" className="btn btn-primary">
					Submit
				</button>
				<button
					type="button"
					className="btn btn-outline-primary"
					onClick={handleReset}
				>
					Reset
				</button>
			</div>
		</form>
	);
};

export default PromptForm;
